import { ScreenSearch, ScreenDetail, ScreenList } from "@/components/AppScreens";

export const GALLERY = {
  "icd10-on-the-go-2026": [
    (active = true) => (
      <ScreenSearch
        active={active}
        appLabel="ICD-10 On the Go" title="Code Search" query="diab"
        chips={["Billable", "2026", "Ch. 4"]}
        rows={[
          ["E11.9", "Type 2 diabetes mellitus without complications"],
          ["E10.9", "Type 1 diabetes mellitus without complications"],
          ["E13.9", "Other specified diabetes mellitus"],
          ["R73.01", "Prediabetes"],
          ["E11.65", "Type 2 diabetes with hyperglycemia"],
        ]}
      />
    ),
    () => (
      <ScreenDetail
        back="Browse" code="M54.5" name="Low back pain"
        chips={["Billable", "2026", "Code notes"]}
        noteLabel="Type 1 Excludes"
        note="low back strain (S39.012) · lumbago due to intervertebral disc displacement (M51.2-) · lumbago with sciatica (M54.4-)"
        actions={["Add to favorites", "View coding notes"]}
      />
    ),
    () => (
      <ScreenList
        appLabel="ICD-10 On the Go" title="Favorites"
        items={[["Cardiology", "24 codes"], ["Endocrinology", "18 codes"], ["Primary care", "42 codes"], ["Audit prep", "9 codes"]]}
        dashed="New folder"
        footer="Synced across iPhone · iPad · Mac"
      />
    ),
  ],
  "icd10-medical-codes": [
    (active = true) => (
      <ScreenSearch
        active={active}
        appLabel="ICD-10-CM 2026" title="Code Search" query="heart"
        chips={["Billable", "2026", "Ch. 9"]}
        rows={[
          ["I21.9", "Acute myocardial infarction, unspecified"],
          ["I50.9", "Heart failure, unspecified"],
          ["I10", "Essential (primary) hypertension"],
          ["R07.9", "Chest pain, unspecified"],
          ["I48.91", "Unspecified atrial fibrillation"],
        ]}
      />
    ),
    () => (
      <ScreenDetail
        code="E11.9" name="Type 2 diabetes mellitus without complications"
        noteLabel="Type 1 Excludes"
        note="diabetes mellitus due to underlying condition (E08.-) · drug or chemical induced diabetes (E09.-) · gestational diabetes (O24.4-)"
      />
    ),
    () => (
      <ScreenList
        appLabel="ICD-10-CM 2026" title="Folders"
        items={[["Cardiology", "24 codes"], ["Endocrinology", "18 codes"], ["Primary care", "42 codes"], ["Audit prep", "9 codes"]]}
        footer="iCloud synced · just now"
      />
    ),
  ],
  "icd10-2026": [
    () => <img src="/images/screenshots/icd10-2027/01-official-2027.jpg" alt="ICD 10 2027 — official edition, 2027 with subscription and 2026 free" className="h-full w-full object-contain bg-white" />,
    () => <img src="/images/screenshots/icd10-2027/02-laterality.jpg" alt="ICD 10 2027 — laterality search" className="h-full w-full object-contain bg-white" />,
    () => <img src="/images/screenshots/icd10-2027/03-new-codes.jpg" alt="ICD 10 2027 — new code badges" className="h-full w-full object-contain bg-white" />,
  ],
  acroly: [
    (active = true) => (
      <ScreenSearch
        active={active}
        appLabel="Acroly" title="8,000+ terms" query="radio"
        chips={["Offline", "iPhone · iPad · Mac"]}
        rows={[
          ["RAIU", "Radioactive iodine uptake"],
          ["131I", "Radioactive iodine"],
          ["RISA", "Radioactive iodinated serum albumin"],
          ["RAI", "Radioactive iodine (therapy)"],
          ["RAM", "Radioactive material"],
        ]}
      />
    ),
    () => (
      <ScreenDetail
        back="Search" code="CAD" name="Coronary artery disease"
        chips={["Clinical", "Cardiology", "FTS5 search"]}
        noteLabel="Also in this topic"
        note="ACS · acute coronary syndrome · CABG · coronary artery bypass graft · PCI · percutaneous coronary intervention"
      />
    ),
    () => (
      <ScreenList
        appLabel="Acroly" title="Shared folders"
        items={[["ICU rotation", "Shared · 4 members"], ["Cardiology", "126 terms"], ["Pharmacy", "88 terms"], ["Study group", "Join code AB42"]]}
        footer="Acroly+ · priority sync on"
      />
    ),
  ],
};

export const APP_NAMES = {
  "icd10-on-the-go-2026": "ICD-10 On the Go",
  "icd10-medical-codes": "ICD-10-CM 2026",
  "icd10-2026": "ICD 10 2027",
  acroly: "Acroly",
};
